import { render, staticRenderFns } from "./separateOrderDialog.vue?vue&type=template&id=5885dcc8&"
import script from "./separateOrderDialog.vue?vue&type=script&lang=js&"
export * from "./separateOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./separateOrderDialog.vue?vue&type=style&index=0&id=5885dcc8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports